import React from "react";
import {
  DialogContent,
  CardContent,
  Card,
  makeStyles,
  Button
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import InputField from "components/ui/form/InputField";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { paymentStatusChange } from '../../../shared/api/purple/outbondPayment'
import { toastSuccess, toastError } from "shared/utils";

export const ActionModal = (props) => {
  const { visible, handleDialogClose, data} = props;

  const useStyle = makeStyles((theme) => ({
    table: {
      marginBottom: "1rem",
    },
    card: {
      "& .MuiCardHeader-root": {
        padding: "12px",
        paddingBottom: 0,
      },
      "& .MuiCardContent-root": {
        padding: 0,
      },
    },
  }));
  const classes = useStyle();
  const scheme = Yup.object().shape({
    response_key: Yup.string().required("Please enter response key"),
    cms_ref_number: Yup.string().required("Please enter cms ref number")
  });
  const handleClose = (_) => {
    handleDialogClose(false);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    let param = { ...values };
    let response = null;
    let requestData = {
      "change_to": data?.change_to,
      "response_key": param?.response_key,
      "cms_ref_number": param?.cms_ref_number,
      "source_reference_number": data?.source_reference_number
  }
    if(requestData){
      response = await paymentStatusChange(requestData);
    }
    
    if (response && response.success) {
      toastSuccess(`Status Changed successfully`);
      handleDialogClose(true);
    } else {
      toastError(response.message);
    }
  };

  return (
    <Spin >
      <KisshtDialog
        title="Change status"
        maxWidth={"sm"}
        open={visible}
        handleClose={handleClose}
      >
        <DialogContent>
          <Card className={classes.card}>
            <CardContent>
            <Formik
                initialValues={{
                  response_key: data?.response_key,
                  cms_ref_number: data?.cms_ref_number
                }}
                validationSchema={scheme}
                onSubmit={handleSubmit}
              >
                {({ isValid, isSubmitting, values, touched, setFieldValue, handleChange }) => (
                  <Spin spinning={isSubmitting}>
                    <Form>
                      <Field
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          required
                          id="response_key"
                          label="Response Key"
                          placeholder="Please enter Response Key"
                          name="response_key"
                          component={InputField}
                          touched={touched}
                          value={values.response_key}
                      />
                      <Field
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        required
                        id="cms_ref_number"
                        label="cms ref Number"
                        placeholder="Please enter cms ref number"
                        name="cms_ref_number"
                        component={InputField}
                        touched={touched}
                        value={values.cms_ref_number}
                      />
                      <div style={{ textAlign: "center" }}>
                        <Button
                          disabled={isSubmitting || !isValid}
                          type="submit"
                          size="large"
                          variant="contained"
                          color="primary"
                          className="mt-4 justify-center common_kissht_btn"
                        >
                          Submit
                        </Button>
                      </div>
                    </Form>
                  </Spin>
                )}
              </Formik>
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};
export default ActionModal;